export const getHoldersData = async (coin: string) => {
	try {
		const res = await fetch(`/api/coin-data/holders-data?coin=${coin}`);
		const { holdersData } = await res.json();
		return holdersData;
	} catch (error) {
		console.error(error);
	}
};
